// src/redux/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import Cookies from "js-cookie";

interface AuthState {
  isAuthenticated: boolean;
  userSession: any;
  user: any;
  menuPermissions: any;
}

const initialState: AuthState = {
  isAuthenticated: false,
  userSession: null,
  user: null,
  menuPermissions: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state: any, action: PayloadAction<any>) => {
      const token = action.payload.token;      
      Cookies.set('jwtToken', token, { expires: 7 }); //, httpOnly: true
      localStorage.setItem('jwtToken', JSON.stringify( action.payload));
      const decodedToken = jwtDecode(token);     
      state.isAuthenticated = true;
      state.userSession = decodedToken;
      state.user = decodedToken;
    },
    logout: (state: any) => {
      localStorage.clear();
      state.isAuthenticated = false;
      state.userSession = null;
      state.user = null;
      state.menuPermissions = null;
      Cookies.remove('jwtToken');
      Cookies.remove('menuPermissions');
    },
    menuPermission: (state: any, action: PayloadAction<any>) => {
      state.menuPermissions = action.payload.menuPermissions;
      Cookies.set('menuPermissions', action.payload.menuPermissions, { expires: 7});
    }
  },
});

export const { login, logout,menuPermission } = authSlice.actions;
export default authSlice.reducer;
